import createSelector from 'lib/web/createSelector'
import config from 'constants/config'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'

export const isLuxuryPlusEnabled = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (currentRegion): boolean => isEnabledForFeature('ALL', currentRegion) && config.LUXURY_PLUS_ENABLED,
)

export const isActiveLuxuryPlusMember = createSelector(
  isLuxuryPlusEnabled,
  (state: App.State) => state.loyalty.member.subscription.item?.status === 'ACTIVE',
  (isLuxuryPlusEnabled, isActiveMember): boolean => !!(isLuxuryPlusEnabled && isActiveMember),
)
